package com.devi3east.bashbuddy.features.events.detail.ui

import androidx.lifecycle.ViewModel
import androidx.lifecycle.viewModelScope
import com.devi3east.bashbuddy.features.events.common.EventRepository
import com.devi3east.bashbuddy.features.ticketing.TicketingCapability
import com.devi3east.bashbuddy.routes.Routes
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.flow.update
import kotlinx.coroutines.launch

class EventDetailViewModel(
    private val repository: EventRepository,
    private val ticketingCapability: TicketingCapability,
    private val tokenProvider: () -> String?
) : ViewModel() {

    private val _uiState = MutableStateFlow(EventDetailUiState())
    val uiState = _uiState.asStateFlow()

    fun getEventDetail(eventId: String) {
        val token = tokenProvider()
        viewModelScope.launch {
            _uiState.update { it.copy(isLoading = true, errorMessage = null) }
            val eventResult = repository.getEventById(eventId)
            eventResult.onSuccess { response ->
                val isFav = token?.let { checkIfFavorite(it, eventId) } ?: false
                val prizeListResult = repository.getPrizesByEventId(eventId)
                val prizeList = prizeListResult.fold(
                    onSuccess = { it.prizes },
                    onFailure = {
                        emptyList()
                    }
                )
                _uiState.update {
                    it.copy(
                        isLoading = false,
                        event = response.event,
                        ticketList = if (ticketingCapability.canPurchaseTickets()) response.tickets else emptyList(),
                        showPurchaseButton = !ticketingCapability.canPurchaseTickets(),
                        externalPurchaseUrl = Routes.event(response.event._id, response.event.slug),
                        prizeList = prizeList,
                        isFavorite = isFav,
                        errorMessage = null
                    )
                }
            }.onFailure { e ->
                _uiState.update {
                    it.copy(
                        isLoading = false,
                        errorMessage = e.message ?: "Unknown error"
                    )
                }
            }
        }
    }

    private suspend fun checkIfFavorite(token: String?, eventId: String): Boolean {
        if (token == null) return false // No token → cannot check favorites

        return try {
            val favorites = repository.getFavoriteEvents(token)
            favorites.any { it._id == eventId }
        } catch (e: Exception) {
            false
        }
    }

    fun toggleFavorite() {
        val token = tokenProvider() ?: run {
            return
        }
        val eventId = _uiState.value.event?._id ?: run {
            return
        }
        viewModelScope.launch {
            val currentlyFavorite = _uiState.value.isFavorite
            val success = if (currentlyFavorite) {
                repository.removeFavorite(token, eventId)
            } else {
                repository.addFavorite(token, eventId)
            }
            if (success) {
                _uiState.update { it.copy(isFavorite = !currentlyFavorite) }
            } else {
                // ignore
            }
        }
    }

}